import { render, staticRenderFns } from "./LectureEntityFormList.vue?vue&type=template&id=58546ff6&"
import script from "./LectureEntityFormList.vue?vue&type=script&lang=ts&"
export * from "./LectureEntityFormList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports